export default __webpack_public_path__ + "static/media/x33-logo-b.126b7e7a.svg";